<mat-card *authGroup="['SuperAdmin', 'OperationsManager']" class="user-view">
    <div class="row" *ngIf="user">
        <div class="col-md-6">
            <mat-card-title>
                {{getAttribute('name', user)}}
            </mat-card-title>
        </div>
        <div class="col-md-6 text-end" *ngIf="perm.canMutate()">
            <button mat-stroked-button color="primary" class="me-2" (click)="resetPassword()">
                Reset password
            </button>
            <button (click)="toggleEditMode()" mat-flat-button color="primary">
                {{editMode ? 'Details' : 'Edit'}}
            </button>
        </div>
    </div>
    <p class="mt-2">
        <button mat-stroked-button (click)="backToList()" class="me-2">
            <mat-icon>arrow_back</mat-icon> Back to list
        </button>
    </p>
    <div class="details mt-3" *ngIf="user && !editMode">
        <table>
            <tr>
                <th>
                    Email
                </th>
                <td>
                    {{getAttribute('email', user)}}
                </td>
            </tr>
            <tr>
                <th>
                    Phone number
                </th>
                <td>
                    {{getAttribute('phone_number', user)}}
                </td>
            </tr>
            <tr>
                <th>
                    Role
                </th>
                <td>
                    <mat-chip-list>
                        <mat-chip *ngFor="let role of currentRoles">
                            {{role}}
                        </mat-chip>
                    </mat-chip-list>
                </td>
            </tr>
            <tr>
                <th>
                    Company / Individual
                </th>
                <td>
                    <mat-chip-list>
                        <mat-chip *ngFor="let company of companies">
                            {{company}}
                        </mat-chip>
                    </mat-chip-list>
                </td>
            </tr>
        </table>
    </div>
    <form [formGroup]="updateUserForm" *ngIf="editMode" class="mt-3" (ngSubmit)="save()">
        <div class="row">
            <div class="col-md-6">
                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input formControlName="name" type="text" matInput placeholder="Name">
                        <mat-error *ngIf="updateUserForm.get('name')?.invalid">
                            Name is required
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input readonly formControlName="email" type="email" matInput
                            placeholder="Email">
                        <mat-error *ngIf="updateUserForm.get('email')?.invalid">
                            Email is required
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="company-individual-field">
                        <mat-label>Company or individual</mat-label>
                        <div class="company-individual-row">
                            <mat-button-toggle-group name="linkType" [value]="linkType" (change)="setLinkType($event.value)">
                                <mat-button-toggle value="company">Company</mat-button-toggle>
                                <mat-button-toggle value="individual">Individual</mat-button-toggle>
                            </mat-button-toggle-group>
                            <mat-chip-list #companyList aria-label="Company or individual selection" class="company-individual-search">
                                <mat-chip *ngFor="let company of companies" [selectable]="selectable" [removable]="removable" (removed)="removeCompany(company)">
                                    {{company}}
                                    <button matChipRemove *ngIf="removable">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <input *ngIf="linkType === 'company'" #companyInput
                                       [placeholder]="companies.length > 0 ? '' : 'Search companies...'"
                                       formControlName="companySearch"
                                       [matAutocomplete]="companyAuto"
                                       [matChipInputFor]="companyList"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       (matChipInputTokenEnd)="addCompany($event)">
                                <input *ngIf="linkType === 'individual'" #individualInput
                                       [placeholder]="companies.length > 0 ? '' : 'Search individuals...'"
                                       formControlName="individualSearch"
                                       [matAutocomplete]="individualAuto"
                                       [matChipInputFor]="companyList"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       (matChipInputTokenEnd)="addCompany($event)">
                            </mat-chip-list>
                        </div>
                        <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="selectedCompany($event)">
                            <mat-option *ngFor="let company of filteredCompanies | async" [value]="company">
                                {{ company.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-autocomplete #individualAuto="matAutocomplete" (optionSelected)="selectedIndividual($event)">
                            <mat-option *ngFor="let ind of filteredIndividuals | async" [value]="ind">
                                {{ (ind.title ? ind.title + ' ' : '') + ind.first_name + ' ' + ind.last_name }} ({{ getIndividualTypeLabel(ind) }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </p>
            </div>
            <div class="col-md-6">
                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone number</mat-label>
                        <input readonly formControlName="phone_number" type="text" matInput
                            placeholder="Phone number">
                        <mat-error *ngIf="updateUserForm.get('phone_number')?.invalid">
                            Phone number
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Roles</mat-label>
                        <mat-chip-list #roleList aria-label="Role selection">
                            <mat-chip *ngFor="let role of roles" [selectable]="selectable" [removable]="removable"
                                (removed)="remove(role)">
                                {{role}}
                                <button matChipRemove *ngIf="removable">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip>
                            <input #roleInput placeholder="Add role..." formControlName="roles" [matAutocomplete]="auto"
                                [matChipInputFor]="roleList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                (matChipInputTokenEnd)="add($event)">
                        </mat-chip-list>
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let role of filteredRoles | async" [value]="role">
                            {{role}}
                        </mat-option>
                    </mat-autocomplete>
                </p>
            </div>
        </div>
        <div class="text-end mt-2">
            <button mat-raised-button color="primary">
                <mat-icon>save</mat-icon> Save
            </button>
        </div>
    </form>
</mat-card>